import styled from 'styled-components';

export const Container = styled.div`

    background: #e4ddcc;
    background: -moz-linear-gradient(top, #e4ddcc 0%, #ffffff 100%);
    background: -webkit-linear-gradient(top, #e4ddcc 0%,#ffffff 100%);
    background: linear-gradient(to bottom, #e4ddcc 0%,#ffffff 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#e4ddcc', endColorstr='#ffffff',GradientType=0 );
    margin: -11px -13px;
    border-radius: 0 0 10px 6px;
    box-shadow: 0 7px 10px rgb(0 0 0 / 20%);
    text-align: center;
    color: #32465B;
    padding: 20px 30px;
    width: calc(100% - -27px);


    .titulo {
        font-size: 2.2rem;
        text-shadow: 0 1px 0 #32465b;
        color: #FF50A7;
        display: block;
        font-family: 'Lilita One', Calibri, cursive;
    }
    .subtitulo {
        font-size: 1.5rem;
        margin-bottom: 10px;
        font-family: 'Lilita One', Calibri, cursive;
        margin-bottom: 0.5rem;
        display: block;
    }
    .destk {
        font-size: 1rem;
        font-weight: bold;
        margin-bottom: 10px;
        display: block;
    }
    .vantagens {
        color: #FF50A7;
        font-size: 1rem;
        display: block;
    }
    .mini {
        display: flex;
        align-items: center;
        font-weight: bold;
        margin: 0 10px;
        font-size: 1rem;
        line-height: 0.9rem;
    }
    .mini:first-child {
        text-align: right;
    }
    .mini:last-child {
        text-align: left;
    }
    .preco {
        display: flex;
        flex-direction: row;
        justify-content: center;
    }
    .valor {
        font-size: 3.5rem;
        color: #53C3BA;
        text-shadow: 0 2px 0 #32465b;
        font-family: 'Lilita One', Calibri, cursive;
        display: block;
    }
    .destk2 {
        color: #FF50A7;
        font-size: 1.1rem;
        display: block;
        font-weight: bold;
    }
    .caminho {
        font-size: 0.9rem;
        font-weight: bold;
        margin: 10px 0;
        display: block;
    }

    .botao {
        background: #FF50A7;
        color: #fff;
        font-weight: 100;
        display: block;
        text-transform: uppercase;
        text-align: center;
        -webkit-border-radius: 20px;
        -moz-border-radius: 20px;
        border-radius: 20px;
        font-size: 1.2rem;
        padding: 8px;
        -webkit-box-shadow: 1px 1px 3px -1px rgb(0 0 0 / 85%);
        -moz-box-shadow: 1px 1px 3px -1px rgba(0,0,0,0.85);
        box-shadow: 1px 1px 3px -1px rgb(0 0 0 / 85%);
        text-shadow: 1px 1px 0 rgb(0 0 0 / 25%);
        cursor: pointer;
        margin-top: 14px;
        border: none;
        text-decoration: none;
        font-family: 'Lilita One', Calibri, cursive;
    }
    .aviso{ font-size: 0.7rem}
`